import { render, staticRenderFns } from "./GhostInput.vue?vue&type=template&id=97c85dc4"
import script from "./GhostInput.vue?vue&type=script&lang=js"
export * from "./GhostInput.vue?vue&type=script&lang=js"
import style0 from "./GhostInput.vue?vue&type=style&index=0&id=97c85dc4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports